import { createStore, createEffect, createEvent, sample } from "effector";
import { termsService } from "../service/termsService";
import { TermsState } from "../model/types";

// Initial state
const initialState: TermsState = {
  expenditures: [],
  fundingRanges: [],
  fundingTypes: [],
  sectors: [],
  loading: false,
  error: null,
  initialized: false,
};

// Effects
export const fetchAllTermsFx = createEffect(termsService.fetchAllTerms);

// Events
export const fetchAllTerms = createEvent();

// Store
export const $termsStore = createStore<TermsState>(initialState)
  .on(fetchAllTermsFx.pending, (state) => ({
    ...state,
    loading: true,
    error: null,
  }))
  .on(fetchAllTermsFx.doneData, (state, data) => ({
    ...state,
    expenditures: Array.isArray(data.expenditures) ? data.expenditures : [],
    fundingRanges: Array.isArray(data.fundingRanges) ? data.fundingRanges : [],
    fundingTypes: Array.isArray(data.fundingTypes) ? data.fundingTypes : [],
    sectors: Array.isArray(data.sectors) ? data.sectors : [],
  }))
  .on(fetchAllTermsFx.fail, (state, { error }) => ({
    ...state,
    error: error.message,
  }))

  .on(fetchAllTermsFx.finally, (state) => ({
    ...state,
    loading: false,
    initialized: true,
  }));

// Wiring
sample({
  clock: fetchAllTerms,
  target: fetchAllTermsFx,
});
